import styled, { css } from 'styled-components'

export const Wrapper = styled.div`
  position: relative;
`
export const Grid = styled.div<{ count: number }>`
  display: grid;
  grid-template-columns: repeat(6, 1fr);
  grid-template-rows: repeat(4, 1fr);
  grid-gap: 8px;
  height: 550px;

  & > div {
    cursor: pointer;
    background-position: center center;
    background-size: cover;
  }

  ${({ count }) =>
    count >= 5 &&
    `
    & > div:first-child {
      grid-column: 1/5;
      grid-row: 1/5;
      border-top-left-radius: 20px;
      border-bottom-left-radius: 20px;
    } 

    & > div:nth-child(2) {
      grid-column: 5/6;
      grid-row: 1/3;
    }

    & > div:nth-child(3) {
      border-top-right-radius: 20px;
    } 
    
    & > div:last-child {
      grid-column: 5/7;
      grid-row: 3/5;
      border-bottom-right-radius: 20px;
    }
  `}

  ${({ count }) =>
    count === 4 &&
    `
    & > div:first-child {
      grid-column: 1/5;
      grid-row: 1/5;
      border-top-left-radius: 20px;
      border-bottom-left-radius: 20px;
    } 

    & > div:nth-child(2) {
      grid-column: 5/6;
      grid-row: 1/3;
    }
    
    & > div:nth-child(3) {
      grid-column: 6/6;
      grid-row: 1/3;
      border-top-right-radius: 20px;
    }
    
    & > div:last-child {
      grid-column: 5/7;
      grid-row: 3/5;
      border-bottom-right-radius: 20px;
    }
  `}

  ${({ count }) =>
    count === 3 &&
    `
    & > div:first-child {
      grid-column: 1/5;
      grid-row: 1/5;
      border-top-left-radius: 20px;
      border-bottom-left-radius: 20px;
    } 

    & > div:nth-child(2) {
      grid-column: 5/7;
      grid-row: 1/3;
      border-top-right-radius: 20px;
    }
    
    & > div:nth-child(3) {
      grid-column: 5/7;
      grid-row: 3/5;
      border-bottom-right-radius: 20px;
    }
  `}

  ${({ count }) =>
    count === 2 &&
    `
    & > div:first-child {
      grid-column: 1/4;
      grid-row: 1/5;
      border-top-left-radius: 20px;
      border-bottom-left-radius: 20px;
    } 

    & > div:last-child {
      grid-column: 4/7;
      grid-row: 1/5;
      border-top-right-radius: 20px;
      border-bottom-right-radius: 20px;
    } 
  `}

  ${({ count }) =>
    count === 1 &&
    `
    & > div {
      grid-column: 1/7;
      grid-row: 1/5;
      border-radius: 20px;
    } 
  `}
  
  @media (max-width: 768px) {
    display: none;
  }
`
export const Carousel = styled.div`
  display: none;
  width: 100vw;
  position: relative;
  left: -25px;

  .swiper-pagination-bullet {
    background: white;
    opacity: 1;
  }
  .swiper-pagination-bullet-active {
    background: var(--brand-primary);
  }

  @media (max-width: 768px) {
    display: block;
  }
`
export const ProductImage = styled.div`
  height: 250px;
  background-position: centre;
  background-size: cover;
`
export const More = styled.span`
  border-radius: 64px;
  background: var(--brand-secondary);
  color: white;
  font-size: 16px;
  padding: 12px 16px;
  position: absolute;
  bottom: 22px;
  right: 22px;
  cursor: pointer;

  @media (max-width: 768px) {
    display: none;
  }
`